import { LookupValues } from 'src/utils/types';

export const SPLIT_EXPERIMENTS = {
    ACTIVATE_ZHL_DASHBOARD_USER: 'ACTIVATE_ZHL_DASHBOARD_USER',
    TASKS_SUMMARY: 'TASKS_SUMMARY_DARK_RELEASE',
    HOME_LOANS_DASHBOARD_AUTH_MIGRATION: 'HOME_LOANS_DASHBOARD_AUTH_MIGRATION',
    HOME_LOANS_DASHBOARD_ENABLE_DIGITAL_PREAPPROVAL_EXPERIENCE:
        'HOME_LOANS_DASHBOARD_ENABLE_DIGITAL_PREAPPROVAL_EXPERIENCE',
    HOME_LOANS_DASHBOARD_SHORT_AUTH: 'HOME_LOANS_DASHBOARD_SHORT_AUTH',
} as const;

export type ActiveSplitExperiment = LookupValues<typeof SPLIT_EXPERIMENTS>;
export const UNIVERSAL_SPLIT_EXPERIMENTS = [
    SPLIT_EXPERIMENTS.ACTIVATE_ZHL_DASHBOARD_USER,
    SPLIT_EXPERIMENTS.TASKS_SUMMARY,
    SPLIT_EXPERIMENTS.HOME_LOANS_DASHBOARD_AUTH_MIGRATION,
    SPLIT_EXPERIMENTS.HOME_LOANS_DASHBOARD_SHORT_AUTH,
];
export const FEATURE_FLAG_STATUS = {
    OFF: 'off',
    ON: 'on',
};
